<template>
  <section class="ege-schedule">
    <div class="ege-schedule__top">
      <h2
        v-if="isTablet"
        class="ege-schedule__title"
      >
        Расписание занятий
      </h2>
      <h2
        v-else
        class="ege-schedule__title"
      >
        Расписание
      </h2>

      <p class="ege-schedule__description">
        Ознакомьтесь с расписанием годового курса 23/24 года
        и получите бесплатный демо-доступ к любому предмету
      </p>
    </div>

    <div class="ege-schedule__subjects">
      <custom-scroll-slider
        :items="subjectsList"
        :container-width="1240"
        :gap="2"
        class="ege-schedule__subjects--list"
      >
        <template #item="{ slide: item }">
          <button
            class="ege-schedule__subjects--btn"
            :class="{ 'active': item.isActive }"
            @click="toggleSubject(item.type)"
          >
            {{ item.label }}
          </button>
        </template>
      </custom-scroll-slider>
    </div>

    <div class="v2-container-small">
      <div class="ege-schedule__table">
        <div class="ege-schedule__table--inner">
          <div
            ref="scrollableElement"
            class="ege-schedule__table--inner-content"
            @scroll="onTableScroll"
            @mousedown="scrollMousedown($event)"
            @mouseleave="scrollMouseleave"
            @mouseup="scrollMouseup"
            @mousemove="scrollMousemove($event)"
          >
            <div
              ref="table"
              class="table scroll-me"
              :class="{ 'oge': pageType === 'oge' }"
            >
              <div
                v-for="col of scheduleData"
                :key="col.id"
                class="table__col"
              >
                <div class="table__col-head">
                  {{ col.day }}
                </div>
                <div class="table__col-cards">
                  <exam-schedule-card
                    v-for="card of col.subjects"
                    :key="card.id"
                    :card="card"
                    @openModal="
                      (modalType, modalTitle) => $emit('openModal', modalType, modalTitle)
                    "
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            ref="scrollParent"
            class="scroll"
          >
            <div
              ref="scrollBar"
              class="scroll__bar"
              @mousedown="scrollbarOnMouseDown($event)"
              @dragstart="scrollbarOnDragStart"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import CustomScrollSlider from '../common/CustomScrollSlider.vue';
import ExamScheduleCard from './ExamScheduleCard.vue';

export default {
  name: 'ExamSchedule',
  components: {
    CustomScrollSlider,
    ExamScheduleCard,
  },

  props: {
    pageType: {
      type: String,
      default: 'ege',
    },
  },
  data: () => ({
    activeSubjects: ['all'],
    allSubjects: [
      {
        id: 1,
        type: 'all',
        label: 'Все предметы',
      },
      {
        id: 2,
        type: 'matematika-profil',
        label: 'Математика (проф.)',
      },
      {
        id: 3,
        type: 'math-base',
        label: 'Математика (база)',
      },
      {
        id: 4,
        type: 'math',
        label: 'Математика',
      },
      {
        id: 5,
        type: 'russkij-yazyk',
        label: 'Русский',
      },
      {
        id: 6,
        type: 'anglijskij-yazyk',
        label: 'Английский',
      },
      {
        id: 7,
        type: 'informatika',
        label: 'Информатика',
      },
      {
        id: 8,
        type: 'obshchestvoznanie',
        label: 'Обществознание',
      },
      {
        id: 9,
        type: 'istoriya',
        label: 'История',
      },
      {
        id: 10,
        type: 'fizika',
        label: 'Физика',
      },
      {
        id: 11,
        type: 'himiya',
        label: 'Химия',
      },
      {
        id: 12,
        type: 'literatura',
        label: 'Литература',
      },
      {
        id: 13,
        type: 'biologiya',
        label: 'Биология',
      },
    ],
    scrollSettings: {
      suppressScrollY: false,
      suppressScrollX: false,
      wheelPropagation: false,
      maxScrollbarLength: 400,
    },
    scrolled: 0,
    // drag scroll
    isDown: false,
    startX: 0,
    scrollLeft: 0,
  }),
  computed: {
    ...mapGetters({
      isTablet: 'isTablet',
    }),
    subjectsList() {
      if (this.pageType === 'ege') {
        return this.allSubjects
          .filter((subject) => subject.type !== 'math')
          .map((subject) => ({
            ...subject,
            isActive: this.activeSubjects.includes(subject.type),
          }));
      }
      if (this.pageType === 'oge') {
        return this.allSubjects
          .filter((subject) => !['math-base', 'matematika-profil', 'anglijskij-yazyk'].includes(subject.type))
          .map((subject) => ({
            ...subject,
            isActive: this.activeSubjects.includes(subject.type),
          }));
      }
      return [];
    },
    egeSchedule() {
      const checkInactive = (type) => (
        !this.activeSubjects.includes('all') && !this.activeSubjects.includes(type)
      );

      return [
        {
          id: 1,
          day: 'Пн',
          subjects: [
            {
              id: 1,
              time: '16:00-17:30',
              label: 'Обществознание',
              tutor: 'Андрей Аксенов',
              tutorPhoto: '/v2/ege/schedule/aksenov.png',
              className: 'obshchestvoznanie',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Обществознание, Пн в 16:00-17:30»',
              isInactive: checkInactive('obshchestvoznanie'),
            },
            {
              id: 2,
              time: '17:40-19:10',
              label: 'Математика (проф.)',
              tutor: 'Германович Олег',
              tutorPhoto: '/v2/ege/schedule/germanovich.png',
              className: 'math',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Математика (проф.), Пн в 17:40-19:10»',
              isInactive: checkInactive('matematika-profil'),
            },
            {
              id: 3,
              time: '19:20-20:50',
              label: 'Математика (база)',
              tutor: 'Германович Олег',
              tutorPhoto: '/v2/ege/schedule/germanovich.png',
              className: 'math',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Математика (база), Пн в 19:20-20:50»',
              isInactive: checkInactive('math-base'),
            },
            {
              id: 4,
              time: '19:20-20:50',
              label: 'Информатика',
              tutor: 'Громов Александр',
              tutorPhoto: '/v2/ege/schedule/gromov.png',
              className: 'informatika',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Информатика, Пн в 19:20-20:50»',
              isInactive: checkInactive('informatika'),
            },
          ],
        },
        {
          id: 2,
          day: 'Вт',
          subjects: [
            {
              id: 1,
              time: '16:00-17:30',
              label: 'Литература',
              tutor: 'Павел Загребин',
              tutorPhoto: '/v2/ege/schedule/zagrebin.png',
              className: 'literatura',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Литература, Вт в 16:00-17:30»',
              isInactive: checkInactive('literatura'),
            },
            {
              id: 2,
              time: '17:40-19:10',
              label: 'Химия',
              tutor: 'Наталья Потапова',
              tutorPhoto: '/v2/ege/schedule/potapova.png',
              className: 'himiya',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Химия, Вт в 17:40-19:10»',
              isInactive: checkInactive('himiya'),
            },
            {
              id: 3,
              time: '19:20-20:50',
              label: 'Физика',
              tutor: 'Валентин Цимбал',
              tutorPhoto: '/v2/ege/schedule/cimbal.png',
              className: 'fizika',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Физика, Вт в 19:20-20:50»',
              isInactive: checkInactive('fizika'),
            },
            {
              id: 4,
              time: 'бесплатно',
              label: 'профтест',
              tutor: 'Запишитесь на онлайн-консультацию с экспертом',
              tutorPhoto: null,
              className: 'istoriya',
              link: '/proforientacia',
              linkText: 'Перейти к записи',
              isInactive: false,
            },
          ],
        },
        {
          id: 3,
          day: 'Ср',
          subjects: [
            {
              id: 1,
              time: '16:00-17:30',
              label: 'Информатика',
              tutor: 'Громов Александр',
              tutorPhoto: '/v2/ege/schedule/gromov.png',
              className: 'informatika',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Информатика, Ср в 16:00-17:30»',
              isInactive: checkInactive('informatika'),
            },
            {
              id: 2,
              time: '16:00-17:30',
              label: 'Биология',
              tutor: 'Алексей Тосканов',
              tutorPhoto: '/v2/ege/schedule/toskanov.png',
              className: 'biologiya',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Биология, Ср в 16:00-17:30»',
              isInactive: checkInactive('biologiya'),
            },
            {
              id: 3,
              time: '16:00-17:30',
              label: 'Английский язык',
              tutor: 'Ксения Морозова',
              tutorPhoto: '/v2/ege/schedule/morozova.png',
              className: 'anglijskij-yazyk',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Английский язык, Ср в 16:00-17:30»',
              isInactive: checkInactive('anglijskij-yazyk'),
            },
            {
              id: 4,
              time: '17:40-19:10',
              label: 'История',
              tutor: 'Алексей Малыгин',
              tutorPhoto: '/v2/ege/schedule/maligin.png',
              className: 'istoriya',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«История, Ср в 17:40-19:10»',
              isInactive: checkInactive('istoriya'),
            },
            {
              id: 5,
              time: '19:20-20:50',
              label: 'Русский язык',
              tutor: 'Екатерина Викторович',
              tutorPhoto: '/v2/ege/schedule/victorovich.png',
              className: 'russkij-yazyk',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Русский язык, Ср в 19:20-20:50»',
              isInactive: checkInactive('russkij-yazyk'),
            },
          ],
        },
        {
          id: 4,
          day: 'Чт',
          subjects: [
            {
              id: 1,
              time: '17:40-19:10',
              label: 'Математика (проф.)',
              tutor: 'Германович Олег',
              tutorPhoto: '/v2/ege/schedule/germanovich.png',
              className: 'math',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Математика (проф.), Чт в 17:40-19:10»',
              isInactive: checkInactive('matematika-profil'),
            },
            {
              id: 2,
              time: '19:20-20:50',
              label: 'Математика (проф.)',
              tutor: 'Германович Олег',
              tutorPhoto: '/v2/ege/schedule/germanovich.png',
              className: 'math',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Математика (проф.), Чт в 19:20-20:50»',
              isInactive: checkInactive('matematika-profil'),
            },
          ],
        },
        {
          id: 5,
          day: 'Пт',
          subjects: [
            {
              id: 1,
              time: '16:00-17:30',
              label: 'Литература',
              tutor: 'Павел Загребин',
              tutorPhoto: '/v2/ege/schedule/zagrebin.png',
              className: 'literatura',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Литература, Пт в 16:00-17:30»',
              isInactive: checkInactive('literatura'),
            },
            {
              id: 2,
              time: '16:00-17:30',
              label: 'Химия',
              tutor: 'Наталья Потапова',
              tutorPhoto: '/v2/ege/schedule/potapova.png',
              className: 'himiya',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Химия, Пт в 16:00-17:30»',
              isInactive: checkInactive('himiya'),
            },
            {
              id: 3,
              time: '16:00-17:30',
              label: 'Английский язык',
              tutor: 'Ксения Морозова',
              tutorPhoto: '/v2/ege/schedule/morozova.png',
              className: 'anglijskij-yazyk',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Английский язык, Пт в 16:00-17:30»',
              isInactive: checkInactive('anglijskij-yazyk'),
            },
            {
              id: 4,
              time: '17:40-19:10',
              label: 'Обществознание',
              tutor: 'Андрей Аксенов',
              tutorPhoto: '/v2/ege/schedule/aksenov.png',
              className: 'obshchestvoznanie',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Обществознание, Пт в 17:40-19:10»',
              isInactive: checkInactive('obshchestvoznanie'),
            },
            {
              id: 5,
              time: '19:20-20:50',
              label: 'Русский язык',
              tutor: 'Екатерина Викторович',
              tutorPhoto: '/v2/ege/schedule/victorovich.png',
              className: 'russkij-yazyk',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Русский язык, Пт в 19:20-20:50»',
              isInactive: checkInactive('russkij-yazyk'),
            },
          ],
        },
        {
          id: 6,
          day: 'Сб',
          subjects: [
            {
              id: 1,
              time: '12:00-13:30',
              label: 'Физика',
              tutor: 'Валентин Цимбал',
              tutorPhoto: '/v2/ege/schedule/cimbal.png',
              className: 'fizika',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Физика, Сб в 12:00-13:30»',
              isInactive: checkInactive('fizika'),
            },
            {
              id: 2,
              time: '13:30-15:00',
              label: 'История',
              tutor: 'Алексей Малыгин',
              tutorPhoto: '/v2/ege/schedule/maligin.png',
              className: 'istoriya',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«История, Сб в 13:30-15:00»',
              isInactive: checkInactive('istoriya'),
            },
            {
              id: 3,
              time: '18:00-19:30',
              label: 'Биология',
              tutor: 'Алексей Тосканов',
              tutorPhoto: '/v2/ege/schedule/toskanov.png',
              className: 'biologiya',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Биология, Сб в 18:00-19:30»',
              isInactive: checkInactive('biologiya'),
            },
          ],
        },
      ];
    },
    ogeSchedule() {
      const checkInactive = (type) => (
        !this.activeSubjects.includes('all') && !this.activeSubjects.includes(type)
      );

      return [
        {
          id: 1,
          day: 'Пн',
          subjects: [
            {
              id: 1,
              time: '17:40-19:10',
              label: 'Информатика',
              tutor: 'Александр Громов',
              tutorPhoto: '/v2/ege/schedule/gromov.png',
              className: 'informatika',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Информатика, Пн в 17:40-19:10»',
              isInactive: checkInactive('informatika'),
            },
            {
              id: 2,
              time: '19:20-20:50',
              label: 'Обществознание',
              tutor: 'Андрей Аксенов',
              tutorPhoto: '/v2/ege/schedule/aksenov.png',
              className: 'obshchestvoznanie',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Обществознание, Пн в 19:20-20:50»',
              isInactive: checkInactive('obshchestvoznanie'),
            },
            {
              id: 3,
              time: 'бесплатно',
              label: 'профтест',
              tutor: 'Запишитесь на онлайн-консультацию с экспертом',
              tutorPhoto: null,
              className: 'istoriya',
              link: '/proforientacia',
              linkText: 'Перейти к записи',
              isInactive: false,
            },
          ],
        },
        {
          id: 2,
          day: 'Вт',
          subjects: [
            {
              id: 1,
              time: '16:00-17:30',
              label: 'Химия',
              tutor: 'Наталья Потапова',
              tutorPhoto: '/v2/ege/schedule/potapova.png',
              className: 'himiya',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Химия, Вт в 16:00-17:30»',
              isInactive: checkInactive('himiya'),
            },
            {
              id: 2,
              time: '16:00-17:30',
              label: 'Английский язык',
              tutor: 'Ксения Морозова',
              tutorPhoto: '/v2/ege/schedule/morozova.png',
              className: 'anglijskij-yazyk',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Английский язык, Вт в 16:00-17:30»',
              isInactive: checkInactive('anglijskij-yazyk'),
            },
            {
              id: 3,
              time: '17:40-19:10',
              label: 'Физика',
              tutor: 'Валентин Цимбал',
              tutorPhoto: '/v2/ege/schedule/cimbal.png',
              className: 'fizika',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Физика, Вт в 17:40-19:10»',
              isInactive: checkInactive('fizika'),
            },
            {
              id: 4,
              time: '19:20-20:50',
              label: 'Русский язык',
              tutor: 'Настя Коноваленко',
              tutorPhoto: '/v2/ege/schedule/konovalenko.png',
              className: 'russkij-yazyk',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Русский язык, Вт в 19:20-20:50»',
              isInactive: checkInactive('russkij-yazyk'),
            },
          ],
        },
        {
          id: 3,
          day: 'Ср',
          subjects: [
            {
              id: 1,
              time: '16:00-17:30',
              label: 'Математика',
              tutor: 'Сергей Тихонов',
              tutorPhoto: '/v2/ege/schedule/tihonov.png',
              className: 'math',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Математика, Ср в 16:00-17:30»',
              isInactive: checkInactive('math'),
            },
            {
              id: 2,
              time: '17:40-19:10',
              label: 'Информатика',
              tutor: 'Александр Громов',
              tutorPhoto: '/v2/ege/schedule/gromov.png',
              className: 'informatika',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Информатика, Ср в 17:40-19:10»',
              isInactive: checkInactive('informatika'),
            },
            {
              id: 3,
              time: '19:20-20:50',
              label: 'История',
              tutor: 'Алексей Малыгин',
              tutorPhoto: '/v2/ege/schedule/maligin.png',
              className: 'istoriya',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«История, Ср в 19:20-20:50»',
              isInactive: checkInactive('istoriya'),
            },
            {
              id: 4,
              time: '19:20-20:50',
              label: 'Биология',
              tutor: 'Дарья Климанович',
              tutorPhoto: '/v2/ege/schedule/klimanovich.png',
              className: 'biologiya',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Биология, Ср в 19:20-20:50»',
              isInactive: checkInactive('biologiya'),
            },
          ],
        },
        {
          id: 4,
          day: 'Чт',
          subjects: [
            {
              id: 1,
              time: '17:40-19:10',
              label: 'Химия',
              tutor: 'potapova',
              tutorPhoto: '/v2/ege/schedule/potapova.png',
              className: 'himiya',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Химия, Чт в 17:40-19:10»',
              isInactive: checkInactive('himiya'),
            },
            {
              id: 2,
              time: '19:20-20:50',
              label: 'Литература',
              tutor: 'Софья Соболева',
              tutorPhoto: '/v2/ege/schedule/soboleva.png',
              className: 'literatura',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Литература, Чт в 19:20-20:50»',
              isInactive: checkInactive('literatura'),
            },
          ],
        },
        {
          id: 5,
          day: 'Пт',
          subjects: [
            {
              id: 1,
              time: '15:00-16:30',
              label: 'Математика',
              tutor: 'Сергей Тихонов',
              tutorPhoto: '/v2/ege/schedule/tihonov.png',
              className: 'math',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Математика, Пт в 15:00-16:30»',
              isInactive: checkInactive('math'),
            },
            {
              id: 2,
              time: '17:40-19:10',
              label: 'Русский язык',
              tutor: 'Настя Коноваленко',
              tutorPhoto: '/v2/ege/schedule/konovalenko.png',
              className: 'russkij-yazyk',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Русский язык, Пт в 17:40-19:10»',
              isInactive: checkInactive('russkij-yazyk'),
            },
            {
              id: 3,
              time: '19:20-20:50',
              label: 'Обществознание',
              tutor: 'Андрей Аксенов',
              tutorPhoto: '/v2/ege/schedule/aksenov.png',
              className: 'obshchestvoznanie',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Обществознание, Пт в 19:20-20:50»',
              isInactive: checkInactive('obshchestvoznanie'),
            },
          ],
        },
        {
          id: 6,
          day: 'Сб',
          subjects: [
            {
              id: 1,
              time: '10:30-12:00',
              label: 'Физика',
              tutor: 'Валентин Цимбал',
              tutorPhoto: '/v2/ege/schedule/cimbal.png',
              className: 'fizika',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Физика, Сб в 10:30-12:00»',
              isInactive: checkInactive('fizika'),
            },
            {
              id: 2,
              time: '10:30-12:00',
              label: 'Английский язык',
              tutor: 'Ксения Морозова',
              tutorPhoto: '/v2/ege/schedule/morozova.png',
              className: 'anglijskij-yazyk',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Английский язык, Сб в 10:30-12:000»',
              isInactive: checkInactive('anglijskij-yazyk'),
            },
            {
              id: 3,
              time: '12:00-13:30',
              label: 'История',
              tutor: 'Алексей Малыгин',
              tutorPhoto: '/v2/ege/schedule/maligin.png',
              className: 'istoriya',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«История, Сб в 12:00-13:30»',
              isInactive: checkInactive('istoriya'),
            },
            {
              id: 4,
              time: '12:00-13:30',
              label: 'Литература',
              tutor: 'Софья Соболева',
              tutorPhoto: '/v2/ege/schedule/soboleva.png',
              className: 'literatura',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Литература, Сб в 12:00-13:30»',
              isInactive: checkInactive('literatura'),
            },
            {
              id: 5,
              time: '13:30-15:00',
              label: 'Биология',
              tutor: 'Дарья Климанович',
              tutorPhoto: '/v2/ege/schedule/klimanovich.png',
              className: 'biologiya',
              // eslint-disable-next-line max-len,vue/max-len
              modalTitle: '<span><span>Бесплатный</span></span> пробный урок по предмету:<br>«Биология, Сб в 13:30-15:00»',
              isInactive: checkInactive('biologiya'),
            },
          ],
        },
      ];
    },
    scheduleData() {
      if (this.pageType === 'ege') {
        return this.egeSchedule;
      }
      if (this.pageType === 'oge') {
        return this.ogeSchedule;
      }
      return [];
    },
  },
  watch: {
    scrolled(newVal) {
      const percent = newVal / 1.7;
      const { scrollWidth, clientWidth } = this.$refs.scrollableElement;
      this.$refs.scrollableElement.scrollLeft = (scrollWidth - clientWidth) * (percent / 100);
    },
  },

  created() {
    if (this.$route.params.subpage === 'matematika') {
      this.toggleSubject(this.pageType === 'ege' ? 'math-base' : 'math');
    } else if (this.$route.params.subpage) {
      this.toggleSubject(this.$route.params.subpage);
    }
  },

  methods: {
    toggleSubject(type) {
      if (type === 'all') {
        this.activeSubjects = ['all'];
        return;
      }
      if (this.activeSubjects.includes(type)) {
        this.activeSubjects = this.activeSubjects.filter((item) => item !== type);
        if (this.activeSubjects.length === 0) {
          this.activeSubjects = ['all'];
        }
        return;
      }
      if (!this.activeSubjects.includes(type)) {
        this.activeSubjects = [
          ...this.activeSubjects.filter((item) => item !== 'all'),
          type,
        ];
      }
    },
    scrollbarOnMouseDown(event) {
      event.preventDefault();

      const { scrollParent, scrollBar } = this.$refs;
      const shiftX = event.clientX - scrollBar.getBoundingClientRect().left;
      const self = this;

      function onMouseMove(evt) {
        let newLeft = evt.clientX - shiftX - scrollParent.getBoundingClientRect().left;

        if (newLeft < 0) {
          newLeft = 0;
        }
        const rightEdge = scrollParent.offsetWidth - scrollBar.offsetWidth;
        if (newLeft > rightEdge) {
          newLeft = rightEdge;
        }

        scrollBar.style.left = `${newLeft}px`;
        self.scrolled = newLeft;
      }

      function onMouseUp() {
        document.removeEventListener('mouseup', onMouseUp);
        document.removeEventListener('mousemove', onMouseMove);
      }

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    },
    scrollbarOnDragStart() {
      return false;
    },
    onTableScroll() {
      const { scrollWidth, clientWidth, scrollLeft } = this.$refs.scrollableElement;
      const percent = scrollLeft / (scrollWidth - clientWidth);

      this.$refs.scrollBar.style.left = `${170 * percent}px`;
      this.scrolled = 170 * percent;
    },
    scrollMousedown(e) {
      if (this.isTablet) return;

      const slider = this.$refs.scrollableElement;
      this.isDown = true;
      slider.classList.add('active');
      this.startX = e.pageX - slider.offsetLeft;
      this.scrollLeft = slider.scrollLeft;
    },
    scrollMouseleave() {
      if (this.isTablet) return;

      const slider = this.$refs.scrollableElement;
      this.isDown = false;
      slider.classList.remove('active');
    },
    scrollMouseup() {
      if (this.isTablet) return;

      const slider = this.$refs.scrollableElement;
      this.isDown = false;
      slider.classList.remove('active');
    },
    scrollMousemove(e) {
      if (!this.isDown || this.isTablet) return;

      e.preventDefault();
      const slider = this.$refs.scrollableElement;
      const x = e.pageX - slider.offsetLeft;
      slider.scrollLeft = this.scrollLeft - (x - this.startX);
    },
  },
};
</script>

<style lang="scss" scoped>
.ege-schedule {
  &__top {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    max-width: 1240px;
    margin: 0 auto;

    @include media-down(tablet) {
      flex-direction: column;
      gap: 12px;
      margin-left: 8px;
      padding: 0 8px;
    }
  }

  &__title {
    font-size: 65px;
    font-weight: 700;
    line-height: 100%;
    letter-spacing: -1.3px;
    text-transform: uppercase;
    color: $black-color;

    @include media-down(tablet) {
      max-width: 250px;
      font-size: 30px;
      letter-spacing: -0.6px;
      text-align: left;
    }
  }

  &__description {
    max-width: 610px;

    font-size: 24px;
    font-weight: 500;
    line-height: 31.2px;
    color: $grey2;

    @include media-down(tablet) {
      font-size: 20px;
      line-height: 20px;
    }
  }

  &__subjects {
    margin-top: 60px;

    @include media-down(tablet) {
      margin-top: 40px;
    }

    &--list {
      padding-bottom: 5px;
      margin-bottom: -5px;
    }

    &--btn {
      padding: 10.5px 30px 14.5px 30px;

      border-radius: 50px;
      border: 2px solid $white-color;
      background-color: $white-color;

      font-variant-numeric: lining-nums proportional-nums;
      font-size: 24px;
      font-weight: 500;
      line-height: 130%;
      color: $black-color;
      white-space: nowrap;

      cursor: pointer;
      transition: all .2s ease-out;

      &:hover {
        border: 2px solid $ege-blue-middle;
      }

      @include media-down(tablet) {
        padding: 10px 20px 10px 20px;

        font-size: 16px;
        line-height: 100%;
      }
    }
    &--btn.active {
      background-color: #9FE3FF;
      box-shadow: 0 4px 0 0 $ege-blue-middle;
      border: 2px solid $ege-blue-middle;
    }
  }

  &__table {
    margin-top: 20px;
    padding: 40px 0;
    overflow: hidden;

    border-radius: 40px;
    background: url('/v2/ege/schedule/background.png') $white-color;
    box-shadow: 4px 4px 20px 0 rgba($ege-blue-middle, .05), 10px 10px 50px 0 rgba($ege-blue-middle, .1);

    &--inner-content {
      overflow-y: scroll;

      &::-webkit-scrollbar {
        display: none;
      }
    }
    &--inner-content.active {
      cursor: grabbing;
      cursor: -webkit-grabbing;
    }

    @include media-down(tablet) {
      margin-top: 24px;
      padding: 20px 0;

      background-size: 350%;
    }
  }

  .table {
    display: grid;
    grid-template-columns: 301px 321px 321px 321px 321px 341px;
    margin: 0 40px;

    @include media-down(tablet) {
      grid-template-columns: 291px 311px 311px 311px 311px 321px;
      margin: 0 20px;
    }

    &__col {
      border-right: 1px dashed rgba($black-color, .3);

      &-head {
        padding-left: 20px;
        padding-bottom: 10px;

        border-bottom: 1px solid rgba($black-color, .3);

        font-feature-settings: 'case' on;
        font-size: 30px;
        font-style: normal;
        font-weight: 700;
        line-height: 130%;
        color: $black-color;

        @include media-down(tablet) {
          padding-left: 10px;
          padding-bottom: 10px;

          font-size: 20px;
        }
      }

      &-cards {
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding: 20px 20px 0;

        @include media-down(tablet) {
          padding: 10px 10px 0;
        }
      }
    }
    &__col:first-of-type {
      .table__col-head {
        padding-left: 0;
      }

      .table__col-cards {
        padding-left: 0;
      }
    }
    &__col:last-of-type {
      border-right: none;
      padding-right: 40px;

      @include media-down(tablet) {
        padding-right: 20px;
      }

      .table__col-cards {
        padding-right: 0;
      }
    }
  }
  .table.oge {
    grid-template-columns: 301px 321px 321px 321px 321px 321px 341px;

    @include media-down(tablet) {
      grid-template-columns: 291px 311px 311px 311px 311px 311px 311px;
    }
  }

  .scroll {
    position: relative;
    width: 400px;
    height: 10px;
    margin: 20px auto 0;

    border-radius: 5px;
    background-color: #EAEFF5;

    @include media-down(tablet) {
      display: none;
    }

    &__bar {
      position: absolute;
      top: 0;
      width: 230px;
      height: 10px;
      box-sizing: border-box;

      border-radius: 5px;
      border: 2px solid $black-color;
      background-color: #9FE3FF;
      cursor: pointer;
    }
  }
}
</style>
